import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SidebarIconDashboard from './sidebar-icon-dashboard.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SidebarIconDashboard {...validProps} />;
}
SvgComponent.iconName = 'sidebarIconDashboard';

/**
 * @deprecated This is a legacy icon
 */
export const SidebarIconDashboardIcon = svgIconWrapper(SvgComponent);
